<template>
    <div id="app">
        <component :is="layout">
            <router-view :key="$route.fullPath" />
        </component>
    </div>
</template>

<script>
    export default {
        name: 'App',
        computed:{
            layout(){
                return this.$route.meta.layout || "default-layout"
            }
        }
    }
</script>

<style>


    @import url('https://fonts.googleapis.com/css?family=PT+Sans&display=swap');



    html, body{
        margin: 0;
        padding: 0;
        background-color: #cedff2;

    }


</style>
